import { render, staticRenderFns } from "./surname.vue?vue&type=template&id=5b235fb6&scoped=true"
import script from "./surname.vue?vue&type=script&lang=js"
export * from "./surname.vue?vue&type=script&lang=js"
import style0 from "./surname.vue?vue&type=style&index=0&id=5b235fb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b235fb6",
  null
  
)

export default component.exports